import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_ENT_HORARIO_CLASES = 'ALL_ENT_HORARIO_CLASES';
export const LOADING_ALL_ENT_HORARIO_CLASES = 'LOADING_ALL_ENT_HORARIO_CLASES';
export const ACTIVO_ENT_HORARIO_CLASES = 'ACTIVO_ENT_HORARIO_CLASES';
export const PARAMS_ENT_HORARIO_CLASES = 'PARAMS_ENT_HORARIO_CLASES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const entHorariosClasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENT_HORARIO_CLASES:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case LOADING_ALL_ENT_HORARIO_CLASES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENT_HORARIO_CLASES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ENT_HORARIO_CLASES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
